<!-- eslint-disable -->
<script setup>
import { useCustomerStore } from '@/stores/customer.js';
import { useCountriesStore } from '@/stores/countries.js';
import { useAccountDetailsStore } from '@/stores/account_details.js';
import { useInitializeStore } from '@/stores/initialize';
import { usePlatformConfigurationStore } from '@/stores/platform_configuration';
import { onMounted, watch, ref, computed } from 'vue';
import { useRouter } from 'vue-router';
import { useAccountStore } from '@/stores/account';
import { useI18n } from 'vue-i18n';
import Swal from 'sweetalert2'
import moment from 'moment';

const accountStore = useAccountStore();
const router = useRouter();
const customerStore = useCustomerStore();
const accountDetailsStore = useAccountDetailsStore();
const initializeStore = useInitializeStore();
const platformConfigurationStore = usePlatformConfigurationStore();

const { t } = useI18n();

const selectedCountryPrefix = ref(customerStore.getCustomer.mobile_country_id);
const form_data = ref({ mobile_country_id: null, mobile_number: null, post_code: null, street_name: null, city: null});
const reset_form = ref({ mobile_country_id: null, mobile_number: null, post_code: null, street_name: null, city: null });
const error_data = ref({});
const loading = ref(false);
const disabled_button = ref(true);
const active_tab = ref('contact_details');
const windowWidth = ref(window.innerWidth);
const is_id_field_enabled = ref(null);

const alert_message = ref('');
const is_country_ghana = process.env.VUE_APP_COUNTRY == 'GHANA';

const goToRoute = (route_path) => {
	if (route_path) router.push({ path: route_path });
	else router.push({ name: 'landing' });
}

const resetForm = () => {
	form_data.value.mobile_country_id = reset_form.value.mobile_country_id;
	form_data.value.mobile_number = reset_form.value.mobile_number;
	form_data.value.post_code = reset_form.value.post_code;
	form_data.value.street_name = reset_form.value.street_name;
	form_data.value.city = reset_form.value.city;
	error_data.value = '';
}

const updateData = () => {
	loading.value = true
	accountDetailsStore.updateAccountDetails(form_data.value).then((response) => {
		selectedCountryPrefix.value = response.data.mobile_country_id;
		reset_form.value = { mobile_country_id: response.data.mobile_country_id, mobile_number: response.data.mobile_number, post_code: response.data.customer_residence.post_code, city: response.data.customer_residence.city, street_name: response.data.customer_residence.street_name };
		alert_message.value = t('account.account_details.success_message');
		fireSwal('success', alert_message.value);
		loading.value = false;
		disabled_button.value = true;
	}).catch((error) => {
		error_data.value = error.data;
		disabled_button.value = true;
		loading.value = false;
	});
}

function isMobileDevice() {
	if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
		return true;
	}

	return false;
}

const showButtons = computed(() => {
	if (initializeStore.screenWidth <= 1279) {
		if (active_tab.value === 'contact_details') return true
		return false
	} else {
		active_tab.value = 'personal_info'
		return true
	}
});

const fireSwal = (alert_type, alert_message) => {
	Swal.fire({
		text: alert_message,
		icon: alert_type,
		confirmButtonText: alert_type == 'success' ? t('account.register.close') : t('general.try_again'),
	});
}

watch(() => form_data.value.mobile_country_id, (newData, oldData) => {
	if(newData != customerStore.getCustomer.mobile_country_id) disabled_button.value = false
	else disabled_button.value = true
})

watch(() => form_data.value.post_code, (newData, oldData) => {
	if(newData != customerStore.getCustomer.post_code) disabled_button.value = false
	else disabled_button.value = true
})

watch(() => form_data.value.street_name, (newData, oldData) => {
	if(newData != customerStore.getCustomer.street_name) disabled_button.value = false
	else disabled_button.value = true
})

watch(() => form_data.value.city, (newData, oldData) => {
	if(newData != customerStore.getCustomer.city) disabled_button.value = false
	else disabled_button.value = true
})

watch(() => form_data.value.mobile_number, (newData, oldData) => {
	if(newData != customerStore.getCustomer.mobile_number) {
		if (error_data.value != null) error_data.value = {}
		disabled_button.value = false
	} else disabled_button.value = true
})

onMounted(() => {
	is_id_field_enabled.value = platformConfigurationStore.isShowNationalIdEnabled;
	form_data.value = { mobile_country_id: customerStore.getCustomer.mobile_country_id, mobile_number: customerStore.getCustomer.mobile_number, post_code:customerStore.getCustomer.customer_residence.post_code, street_name:customerStore.getCustomer.customer_residence.street_name, city:customerStore.getCustomer.customer_residence.city }
	reset_form.value = { mobile_country_id: customerStore.getCustomer.mobile_country_id, mobile_number: customerStore.getCustomer.mobile_number, post_code:customerStore.getCustomer.customer_residence.post_code, street_name:customerStore.getCustomer.customer_residence.street_name, city:customerStore.getCustomer.customer_residence.city }
})
</script>
<template>
		<div class="dashboard-tab-content">
			<div class="tab-content-outer">
				<div class="dash-inner-tabs">
				</div>

				<div class="dash-content-main account-detail-main" id="account-detail">
					<div class="dash-content-outer">
						<div class="dash-main-content">
							<div class="title">
								<h3>{{$t('account.account_details.title')}}</h3>
							</div>
							<div class="tab tab-mobile-dash">
								<button class="inner-tab-item" :class="active_tab == 'personal_info' ? 'active' : ''" @click="active_tab='personal_info'">{{$t('account.account_details.personal')}}</button>
								<button class="inner-tab-item" :class="active_tab == 'contact_details' ? 'active' : ''" @click="active_tab='contact_details'">{{$t('account.account_details.contact')}}</button>
							</div>

							<div class="tabs-outer">
								<div class="tabs-inner" :class="active_tab == 'personal_info' ? 'active' : ''">
									<div class="title">
										<h6>{{$t('account.account_details.personal')}}</h6>
									</div>
									<div class="dashboard-form register-inner-form">
										<div class="register-form-field">
											<label>{{$t('account.account_details.name')}}</label>
											<input readonly class="form-input" :placeholder="$t('account.account_details.name')" type="text" v-model="customerStore.getCustomer.firstname" />
										</div>

										<div class="register-form-field">
											<label>{{$t('account.account_details.surname')}}</label>
											<input readonly class="form-input" :placeholder="$t('account.account_details.surname')" type="text" v-model="customerStore.getCustomer.lastname" />
										</div>
										<div class="register-form-field">
											<label>
												{{$t('account.account_details.date_of_birth')}}</label>
											<input readonly class="form-input" :value="moment(customerStore.getCustomer.dob).format('YYYY-MM-DD')" />
										</div>

										<div v-if="is_id_field_enabled" class="register-form-field">
											<label>
												{{$t('account.account_details.id')}}</label>
											<input readonly class="form-input" :placeholder="$t('account.account_details.id')" type="text" v-model="customerStore.getCustomer.national_id_number" />
										</div>
										<div class="register-form-field">
											<label>{{$t('account.account_details.gender')}}</label>
											<select name="" class="form-input form-control" id="gender" v-model="customerStore.getCustomer.gender" disabled>
												<option value="" disabled>{{$t('account.account_details.gender')}}</option>
												<option value="male">{{ $t('general.male') }}</option>
												<option value="female">{{ $t('general.female') }}</option>
											</select>
										</div>
									</div>
								</div>

								<div class="tabs-inner" :class="active_tab == 'contact_details' ? 'active' : ''">
									<div class="title">
										<h6>{{$t('account.account_details.contact')}}</h6>
									</div>
									<div class="dashboard-form register-inner-form">

										<div v-if="!is_country_ghana" class="register-form-field">
											<label>{{$t('account.register.email_address')}}</label>
											<input readonly class="form-input" :placeholder="$t('account.register.email_address')" type="email" v-model="customerStore.getCustomer.email" />
										</div>

										<div class="register-form-field">
											<label>{{$t('account.account_details.number')}}</label>
											<div class="phone-field">
												<select readonly v-model="customerStore.getCustomer.country_id" name="mobile_prefix" class="form-input form-control select-not-read-only" id="address-country" disabled>
													<option v-for="country in useCountriesStore().getCountries" :value="country.id" :key="country.id">
														+{{ country.mobile_prefix }}
													</option>
												</select>
												<input readonly v-model="customerStore.getCustomer.mobile_number" type="tel" class="form-input" maxlength="15" required style="color: var(--white);" />
											</div>
											<template v-if="error_data.errors != null">
												<div class="register-form-list" >
													<span style="color: var(--red);" v-for="error in error_data.errors.mobile_number" :key="error">{{ error }}</span>
												</div>
											</template>
										</div>

										<div class="register-form-field">
											<label>{{$t('account.account_details.country')}}</label>
											<input readonly class="form-input" v-model="customerStore.getCustomer.customer_residence.country.name" name="country" />

										</div>

										<div class="register-form-field">
											<label> {{$t('account.account_details.address')}}</label>
											<input class="form-input" type="text" name="street_name" v-model="form_data.street_name" />
											<span v-if="error_data && error_data.errors && error_data.errors.street_name" class="error-messages">
												<p style="color: var(--red);" class="error-text" v-for="(error, index) in error_data.errors.street_name" :key="index">{{ error }}</p>
											</span>
										</div>

										<div class="register-form-field">
											<label>
												{{$t('account.account_details.city')}}</label>
											<input class="form-input" type="text" name="city" v-model="form_data.city" />
											<span v-if="error_data && error_data.errors && error_data.errors.city" class="error-messages">
												<p style="color: var(--red);" class="error-text" v-for="(error, index) in error_data.errors.city" :key="index">{{ error }}</p>
											</span>
										</div>

										<div class="register-form-field">
											<label>
												{{$t('account.account_details.postcode')}}</label>
											<input class="form-input" type="text" name="post_code" v-model="form_data.post_code" />
											<span v-if="error_data && error_data.errors && error_data.errors.post_code" class="error-messages">
												<p style="color: var(--red);" class="error-text" v-for="(error, index) in error_data.errors.post_code" :key="index">{{ error }}</p>
											</span>
										</div>
									</div>
								</div>

							</div>
						</div>

						<div v-if="showButtons" class="dashboard-footer">
							<div class="dash-btns">
								<button class="btn" type="button" @click="resetForm()">{{$t('general.cancel')}}</button>
							</div>
							<div class="dash-btns">
								<button class="btn btn-secondary" :class="{'disabled-button': disabled_button}" type="button" @click="updateData()" v-if="!loading">{{$t('general.update')}}</button>
								<button class="btn btn-secondary" type="button" v-else><div class="loader-main"></div></button>
							</div>
						</div>
					</div>
					<div class="close-btn" @click="goToRoute(accountStore.getPreviousRoute)">
						<a href="#"><svg xmlns="http://www.w3.org/2000/svg" width="21.414" height="21.414" viewBox="0 0 21.414 21.414">
								<g id="close" transform="translate(0.707 0.707)">
									<line id="Line_2" data-name="Line 2" x2="20" y2="20" fill="none" stroke="#ffff" stroke-linecap="round" stroke-width="1" />
									<line id="Line_3" data-name="Line 3" x1="20" y2="20" fill="none" stroke="#ffff" stroke-linecap="round" stroke-width="1" />
								</g>
							</svg>
						</a>
					</div>
				</div>
			</div>
		</div>
</template>

<style scoped>
@media screen and (min-width: 320px) and (max-width: 767px) {
	.dashboard-main .dashboard-outer .dash-mobile-title {
		padding:unset;
		padding-bottom: 10px;
		/* padding-top: 10px; */
	}
}
.dashboard-footer .dash-btns button {
	width: 301px;
	padding: 7px 0;
	font-size: 13px;
	font-weight: 500;
	cursor: pointer;
}
.referral-footer .dash-btns .referral-update-btn {
	width: 100%;
	padding: 5px 0;
	font-size: 13px;
	font-weight: 500;
	cursor: pointer;
	margin-top: 27px;
}
.dashboard-main .dashboard-outer .dashboard-tab-content .dash-content-main .dash-content-outer .referral-footer {
	border-top: none;
}
.referral-update-btn--disabled {
	opacity: 0.5;
	pointer-events: none;
}
.disabled-button {
	opacity: 0.5;
	pointer-events: none;
}
html[dir="rtl"] .dashboard-main .dashboard-outer .dashboard-tab-content .dash-content-main .close-btn {
	right: unset!important;
	left: 50px!important;
}
html[dir="rtl"] .dashboard-main .dashboard-outer .dashboard-tab-content .dash-content-main .dash-content-outer .register-inner-form select {
	background-position: 10%;
}
html[dir="rtl"] .dashboard-main .dashboard-outer .dashboard-tab-content .dash-content-main .dash-content-outer .dashboard-footer .dash-btns:last-child {
	text-align: left;
}

@media screen and (min-width: 320px) and (max-width: 767px) {
	.dashboard-main .dashboard-outer .dashboard-tab-content .dash-content-main .dash-content-outer .register-inner-form label {
		display: block;
	}
}

.dashboard-main .dashboard-outer .dashboard-tab-content .tab-content-outer {
	height: 100%;
}
</style>
